.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.8rem 0 1.6rem;

  @media screen and (min-width: $bp-medium) {
    padding: 1.2rem 2.4rem;
  }
}

.table-container {
  padding: 1.6rem;
}

.table {
  border-collapse: collapse;
  width: 100%;
}

.table-header {
  color: var(--color-grayscale-shuttle);
  text-align: left;
  border-bottom: 0.1rem solid var(--color-grayscale-tuna);
}

.t-head {
  height: 3.6rem;
  font-weight: 400;
  font-size: 1.4rem;
  color: var(--color-grayscale-shuttle);
  cursor: default;

  &:first-child {
    padding-left: 1.6rem;
  }
}

.cell {
  font-weight: 400;
  font-size: 1.4rem;
  padding: 0.4rem 1.6rem 0.4rem 0;
  color: var(--color-grayscale-white);
  cursor: default;

  &:first-child {
    padding-inline-start: 1.6rem;
  }

  & input {
    width: 100%;
  }

  & [data-line] {
    max-width: unset;
  }

  &:last-child {
    padding-inline-end: 0.8rem;
  }
}

.row {
  position: relative;
  width: 100%;

  border-bottom: 0.1rem solid var(--color-grayscale-tuna);

  &:last-child {
    border-bottom: none;
  }
}
